import type { IExercise } from '../exercises';

export const FANJUE_EPISODE_15_MATERIALS: IExercise[] = [
  {
    "id": "course-20261008-fanjue-plan-15-01",
    "name": "臀中肌臀小肌激活",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "hip-leg",
    "tips": ["蚌式等臀部激活", "感受臀中肌收缩"],
    "sets": 2,
    "reps": "15次",
    "rpe": 5,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "demoUrl": "/media/collections-20261008/demos/b9f5697e74f2597dbaa8cc27.mp4",
    "videoUrl": "/media/collections-20261008/videos/ac1a34393afa64ca80c09e24.mp4",
    "targetMuscles": ["全身激活肌群"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第15期",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-15-02",
    "name": "青蛙趴拉伸",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "hip-leg",
    "tips": ["蛙式下蹲+动态弹动，打开髋内收", "膝盖打开对准脚尖，重心下沉"],
    "sets": 2,
    "reps": "15",
    "rpe": 2,
    "restSeconds": 20,
    "isBodyweight": true,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "焚诀计划 · 第15期",
    "demoUrl": "/media/collections-20261008/demos/93d8fcc1bc18b33e7ccb3a90.mp4",
    "videoUrl": "/media/collections-20261008/videos/facc3be8f63ee3d0068bfe61.mp4",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-15-03",
    "name": "侧向移动弹力带",
    "bodyPart": "legs",
    "equipment": "resistance-band",
    "subCategory": "glutes",
    "tips": ["侧步走激活臀中肌", "弹力带始终张力"],
    "sets": 2,
    "reps": "15次",
    "rpe": 5,
    "restSeconds": 30,
    "isBodyweight": false,
    "isWarmup": false,
    "demoUrl": "/media/collections-20261008/demos/8fa7914263a2a881841e9673.mp4",
    "videoUrl": "/media/collections-20261008/videos/0ac880a3cfaf0a1a0f6b4d52.mp4",
    "targetMuscles": ["臀中肌", "臀小肌"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第15期",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-15-04",
    "name": "龙门架旋转",
    "bodyPart": "abs",
    "equipment": "cable",
    "subCategory": "obliques",
    "tips": ["绳索伐木旋转", "侧重腹斜肌"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/c825abead5f8aacfb86cacb2.mp4",
    "videoUrl": "/media/collections-20261008/videos/42b0aeec70212192d9a59074.mp4",
    "targetMuscles": ["腹斜肌"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第15期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-15-05",
    "name": "哥本哈根支撑",
    "bodyPart": "abs",
    "equipment": "bodyweight",
    "subCategory": "obliques",
    "tips": ["侧支撑变体", "核心+内收肌"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": true,
    "demoUrl": "/media/collections-20261008/demos/f2bbd663e8bdfa9578399d35.mp4",
    "videoUrl": "/media/collections-20261008/videos/5c280e98c818a5843f4f8818.mp4",
    "targetMuscles": ["腹斜肌", "核心肌群"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第15期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-15-06",
    "name": "宽身功能训练",
    "bodyPart": "legs",
    "equipment": "bodyweight",
    "subCategory": "hamstrings",
    "tips": ["宽距下肢功能训练", "后侧链为主"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": true,
    "demoUrl": "/media/collections-20261008/demos/e97e2d98b4067fb0adc56db8.mp4",
    "videoUrl": "/media/collections-20261008/videos/4cea01ecd64c4e03b3019096.mp4",
    "targetMuscles": ["腘绳肌"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第15期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-15-07",
    "name": "保加利亚蹲",
    "bodyPart": "legs",
    "equipment": "dumbbell",
    "subCategory": "glutes",
    "tips": ["侧重臀部版本", "重心后移"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/fbe259bcb9a9fcda31c48264.mp4",
    "videoUrl": "/media/collections-20261008/videos/533ff52f02e8f823297d2db0.mp4",
    "targetMuscles": ["臀大肌", "股四头肌"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第15期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
];
